import { Route } from 'vue-router';

export const TeamRoute: Record<string, Partial<Route>> = {
  TEAM_INVITE_EXPIRED: {
    path: 'team-invite-expired',
    name: 'team-invite-expired'
  }
};
